export default {
  message: {
    "login": "Login",
    "register": "Register",
    "login_with_google": "Login with Google",
    "guest_login": "Guest Login",
    "or": "OR",
    "email": "Email",
    "password": "Password",
    "no_account": "Don't have an account",
    "click_to_go": "Click to",
    "have_account": "Already have an account",
    "go_to": "Go to",
    "invite_code": "Invite Code",
    "optional": "Optional",
    "google_login_not_ready": "Google login is not ready, please try again later",
    "password_too_long": "Password is too long",
    "weak": "Weak",
    "medium": "Medium",
    "strong": "Strong",
    "login_success": "Login successful",
    "login_failed": "Login failed",
    "please_input_email": "Please enter your email",
    "please_input_phone": "Please enter your phone number",
    "invalid_email": "Invalid email format",
    "email_error_1": "Please enter your email",
    "email_error_2": "Please enter a valid email address",
    "email_error_3": "Guest email is not allowed, please use a real email",
    "please_input_password": "Please enter your password",
    "phone": "Phone",
    "phone_error_1": "Please enter your phone number",
    "phone_error_2": "Please enter a valid phone number",
    "password_length_6_to_16": "Password must be 6-16 characters",
    "account_or_password_error": "Account or password error",
    "register_success": "Registration successful",
    "register_failed": "Registration failed",
    "update_info": "Update Information",
    "update_success": "Update successful",
    "update_failed": "Update failed, please try again later",
    "cancel": "Cancel",
    "error": "An error occurred!",
    "Sorrysomeerrorsoccurred": "Sorry some errors occurred",
    "quit": "Quit",
    "language": "Language",
    "Youcanchangethelanguagehere": "You can change the language here!",
    "current": "Current",
    "home": "Home",
    "friends": "Friends",
    "wallet": "Wallet",
    "aboutus": "About Us",
    "Sharewithfriends": "Share with friends",
    "copyFailure": "Copy Failure",
    "copySuccess": "Copy Success",
    "Claimreward": "Claim reward",
    "DailyLogin": "Daily Login",
    "noInvitationsYet": "No Invitations Yet",
    "LoadMore": "Load More",
    "WatchAD": "Watch AD",
    "continue": "Continue",
    "Congratulations": "Congratulations",
    "MyFriends": "My Friends",
    "Invitefriends": "Invite friends",
    "Invitepremiumfriends": "Invite premium friends",
    "DailyTasks": "Daily tasks",
    "inviteDesc": "+{num} ${name} for each friend you invite",
    "DailyTasksDesc": "Complete tasks to get more ${name}",
    "SponsorsandPartners": "Sponsors and Partners",
    "Receivingwallet": "Receiving wallet",
    "Enterwalletaddress": "Enter {name} wallet address",
    "Claim": "Claim",
    "Booster": "Booster",
    "RentPeriod": "Rent Period",
    "days30": "30 days",
    "days": "days",
    "Dailyprofit": "Daily profit",
    "Totalprofit": "Total profit",
    "Quantity": "Quantity",
    "RentPrice": "Rent Price",
    "RentMiner": "Rent Miner",
    "Insufficient": "Insufficient ${name}",
    "InsufficientMsg": "{num} ${name1} needed, invite friends or complete tasks to earn more ${name2}.",
    "Settings": "Settings",
    "copyid": "Copy ID",
    "UpgradeSuccessfully": "Upgrade Successfully",
    "Name": "Name",
    "userinfo": "Userinfo",
    "disconnect": "Disconnect",
    "Startmining": "Start mining",
    "Welcome": "Welcome to {name}",
    "Withdrawal": "Withdrawal",
    "Minimumamount": "Minimum amount",
    "Networkfee": "Network fee",
    "Enteramount": "Enter amount",
    "Submit": "Submit",
    "MinimumTip": "The withdrawal amount is too small. Minimum withdrawal amount: {num}",
    "MaximumTip": "Insufficient amount, the maximum amount you can withdraw is: {num}",
    "SubmittedTip": "Submitted, expected to be processed within 30-60 working days",
    "WebSubmittedTip": "Submitted, expected to be processed within 24-48 hours",
    "WithdrawStatus": "Status",
    "Submissiontime": "Submission time",
    "WithdrawAwaitTip": "* It is estimated to take 30-60 working days. Inviting more friends can speed up the review process.",
    "WebWithdrawAwaitTip": "* It is estimated to take 24-48 hours. Inviting more friends can speed up the review process.",
    "Processing": "Processing",
    "Success": "Success",
    "Rejection": "Rejection",
    "Amount": "Amount",
    "Numberoffriends": "Number of friends: {now}/{limit}",
    "InviteTip": "To make your first withdrawal, you need to invite {limit} friends to join the mining app.",
    "openonphone": "Open this link on your phone.",
    "claimTip": "The amount to be claimed is too small. The minimum amount to be claimed is: {num}",
    "WalletBalance": "Wallet Balance",
    "Withdraw": "Withdraw",
    "SetWalletAddress": "Set Wallet Address",
    "WithdrawalRecord": "Withdrawal Record",
    "Norecords": "No records",
    "Whatis": "What is {name}?",
    "All": "All",
    "save": "Save",
    "successWithdrawal": "Withdrawal has been received {num}",
    "secondsago": "{time} seconds ago",
    "Loading": "Loading...",
    "PaymentConfirming": "Checking Transaction Status...",
    "Check": "Check",
    "CheckFail": "Transaction not completed. Please check again in 5 seconds.",
    "Addname": "Add '{name}' to your name",
    "Restattcheck": "Restart the app to check",
    "Copyname": "Copy '{name}'",
    "SubmissionFailed": "Submission failed, please try again later",
    "WithdrawalReview": "Withdrawal review",
    "shop": "Shop",
    "topurchase": "Go to the shop to purchase",
    "shopDesc": "Limited availability—get yours before they vanish!",
    "select_payment_method": "Select payment method",
    "total_amount": "Total amount",
    "creating_order": "Creating order...",
    "order_created": "Order created",
    "order_status": "Order status",
    "claim": "Claim",
    "payment_success": "Payment successful",
    "payment_failed": "Payment failed",
    "payment_cancelled": "Payment cancelled",
    "opening_payment": "Opening payment...",
    "payment_status": "Payment status",
    "create_order_failed": "Create order failed",
    "creating_ton_order": "Creating TON order...",
    "creating_usdt_order": "Creating USDT order...",
    "next_step": "Next step",
    "use_ton_payment": "Use TON payment",
    "use_usdt_payment": "Use USDT payment",
    "start_transaction": "Start transaction",
    "connect_wallet": "Connect wallet",
    "address": "Address",
    "amount_ton": "Amount TON",
    "copy": "Copy",
    "amount": "Amount",
    "wallet_address": "Wallet address",
    "comment_memo": "Comment memo",
    "you_can_choose_to_connect_wallet_to_pay": "You can choose to connect wallet to pay",
    "or_manually_transfer_to_the_above_address": "Or manually transfer to the above address (note that the amount and memo must be exactly the same)",
    "or_manually_transfer_to_the_above_address_usdt": "Manually transfer to the above address (note that the amount and address must be exactly the same)",
    "twa_pay_tip_with_memo": "Please ensure the address, amount, and memo are consistent for the transfer.",
    "twa_pay_tip": "Please ensure the address and amount are correct for the transfer.",
    "transaction_success": "Transaction success",
    "transaction_failed": "Transaction failed",
    "transaction_error": "Transaction error",
    "transaction_status": "Transaction status",
    "transaction_id": "Transaction ID",
    "transaction_amount": "Transaction amount",
    "transaction_status_desc": "Transaction status description",
    "payment_status_tip": "Please wait for the payment to be confirmed",
    "Applyforwithdrawal": "Apply for withdrawal",
    "Withdrawalunlock": "Withdrawal unlocking",
    "Close": "Close",
    "Delivering": "Delivering",
    "Duetothelargenumber": "Due to the large number of recipients,your airdrop is expected to arrive in 15-20 working days",
    "WithdrawalunlockTip": "You need {num} invited friends to complete tasks/bind wallets to unlock the withdrawal",
    "select_network": "Select network",
    "confirm": "confirm",
    "switching_network": "Switching network...",
    "network_switched": "Network switched",
    "chain_type": "Network",
    "check_transaction_status": "Check transaction status",
    "transaction_wait": "Transaction is processing. You can exit the app. A message will notify you once it is complete.",
    "affiliate_programs": "Affiliate programs",
    "affiliate_programs_description": "Invite friends to join the mining app and earn rewards.",
    "commission_details": "Commission details",
    "no_commission_records": "No commission records",
    "commission_list": "Commission list",
    "input_amount": "Input amount",
    "max": "Max",
    "commission_input_amount": "Input commission amount",
    "min_commission": "The minimum withdrawal amount is {num}",
    "WithdrawalSuccess": "Withdrawal successful",
    "WithdrawalFailed": "Withdrawal failed",
    "WithdrawalProcessing": "Withdrawal processing",
    "award": "Award",
    "level": "Level",
    "Share_to_group": "Share to group",
    "Exchange": "Exchange",
    "balance_not_enough": "Balance not enough, you can only exchange {num} {coin}",
    "exchange_fail": "Exchange failed",
    "exchange_success": "Exchange successful",
    "you_will_receive": "You will receive",
    "ShareToGroups": "Share to groups",
    "Numberofgroups": "Number of groups: {now}/{limit}",
    "Confirm": "Confirm",
    "ShareToGroupsDesc": "Share to groups to get more {name}",
    "TokenAddress": "Please enter withdrawal details such as exchange ID or USDT address",
    "CashAddress": "Please enter withdrawal details such as bank card number or USDT address",
    "Cancel": "Cancel",
    "min_withdrawal_amount": "The minimum withdrawal amount is {num} {coin}",
    "max_withdrawal_amount": "The maximum withdrawal amount is {num} {coin}",
    "withdrawal_failed": "Withdrawal failed",
    "withdrawal_success": "Withdrawal successful",
    "PayNow": "Pay now",
    "PaySkip": "Pay {num} to instantly unlock withdrawal",
    "NumberofGroups": "Number of groups: {now}/{limit}",
    "SendMessage": "Send message",
    "NumberofShares": "Number of shares: {now}/{limit}",
    "NumberofTasks": "Number of tasks: {now}/{limit}",
    "CompleteTask": "Complete task",
    "PleaseEnterValidAmount": "Please Enter Valid Amount",
    "PleaseEnterValidEmail": "Please Enter Valid Email",
    "Feedback": "Feedback",
    "Inputfeedbackcontent": "Input feedback content",
    "Submitfeedback": "Submit feedback",
    "Pleaseenteravalidemailaddress": "Please enter a valid email address",
    "Pleaseenteryouremailaddress": "Please enter your email address",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "You have already feedbacked today, please come back tomorrow",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "Feedback submitted successfully, thank you for your valuable feedback",
    "Feedback_submission_failed_please_retry": "Feedback submission failed, please retry",
    "ContactUs": "Contact Us",
    "XRPAddress": "Please fill in the activated XRP chain wallet address (including MEMO), otherwise you will not be able to withdraw cash.",
    "Accelerated": "Accelerated",
    "Accelerated_withdrawals_success": "Accelerated withdrawals successfully",
    "save_error": "Save error, please try again later",
    "ShareToFriends": "Share to friends",
    "login_first": "Please login first",
    "WalletBscError": "❌ Invalid BNB Chain wallet address.",
    "DownloadWallet": "Download Wallet",
    "AddToHomeScreen": "Add {appName} to home screen",
    "TapShareInToolbar": "Tap in the toolbar",
    "SelectAddToHomeScreen": "Select add to home screen",
    "OpenToolbar": "Open Toolbar",
    "ClaimFailed": "Claim failed, please try again later",
    "guest_credentials_title": "Account Information",
    "guest_credentials_warning": "Please take a screenshot to save your account and password. If lost, your earnings cannot be recovered!",
    "i_have_saved": "I have saved",
    "account": "Account",
    "view_credentials": "View Credentials",
    "miner_max_reached": "You have reached the maximum number of this miner"
}};